// Components==============
import { EditableProcessEntity } from 'hooks/useProcessGroups';
import { useRedux } from 'hooks/useRedux';
import React, { createContext } from 'react';
import Card from './components/Card/Card';
import './TrainingCard.module.scss';
// =========================

/* eslint-disable react/no-unused-prop-types */

type Props = {
  training?: TrainingEntity;
  process?: EditableProcessEntity;
  withModal?: boolean;
  small?: boolean;
  handleAdd?: () => void;
  handleSwitch?: () => void;
  handleDelete?: () => void;
  canSwitch?: boolean;
  isUsed?: boolean;
  height?: number;
  inLibrary?: boolean;
};

type TrainingCardContextType = {
  categories: (CategoryEntity | undefined)[] | undefined;
  // skills: (SkillEntity | undefined)[] | undefined;
};

export const TrainingCardContext = createContext(
  {} as Props & TrainingCardContextType
);

export default function TrainingCard(props: Props) {
  const categories = useRedux((state) =>
    state.category?.entities.allIds.map(
      (id) => state.category?.entities.byId[id]
    )
  );

  // const skills = useRedux((state) =>
  //   state.skill?.entities.allIds.map((id) => state.skill?.entities.byId[id])
  // );

  return (
    <TrainingCardContext.Provider
      value={{
        ...props,
        categories,
        // skills,
      }}
    >
      <Card />
    </TrainingCardContext.Provider>
  );
}
